<div class="home-container">
  <img ngSrc="assets/images/Transparent-Logo-480w.png" class="logo" alt="Logo" width="480" height="357" priority />
</div>
